/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyContactInfoOnAzure
 */
export interface EmergencyContactInfoOnAzure {
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    phone_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    language_code: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyContactInfoOnAzure
     */
    org_user_role: string | null;
}

/**
 * Check if a given object implements the EmergencyContactInfoOnAzure interface.
 */
export function instanceOfEmergencyContactInfoOnAzure(value: object): value is EmergencyContactInfoOnAzure {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('org_user_role' in value) || value['org_user_role'] === undefined) return false;
    return true;
}

export function EmergencyContactInfoOnAzureFromJSON(json: any): EmergencyContactInfoOnAzure {
    return EmergencyContactInfoOnAzureFromJSONTyped(json, false);
}

export function EmergencyContactInfoOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyContactInfoOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'language_code': json['language_code'],
        'org_user_role': json['org_user_role'],
    };
}

export function EmergencyContactInfoOnAzureToJSON(json: any): EmergencyContactInfoOnAzure {
    return EmergencyContactInfoOnAzureToJSONTyped(json, false);
}

export function EmergencyContactInfoOnAzureToJSONTyped(value?: EmergencyContactInfoOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'language_code': value['language_code'],
        'org_user_role': value['org_user_role'],
    };
}

